// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"q4-z"};